import apiClient from './api';

export default {
  getNewsItems() {
    console.log('Making API request to get news items');
    return apiClient.get('/news/news/')  // This should match your API URL structure
      .then(response => {
        console.log('API response for news items:', response);
        return response;
      })
      .catch(error => {
        console.error('API error for news items:', error);
        throw error;
      });
  },
  getNewsItem(slug) {
    console.log(`Making API request to get news item with slug: ${slug}`);
    return apiClient.get(`/news/news/${slug}/`)  // This should match your API URL structure
      .then(response => {
        console.log('API response for single news item:', response);
        return response;
      })
      .catch(error => {
        console.error(`API error for news item with slug ${slug}:`, error);
        throw error;
      });
  }
};